<template>
	<AsiCard unwrapped>
		<v-expansion-panels flat>
			<v-expansion-panel>
				<v-expansion-panel-header color="secondary lighten-2" class="card-expansion-header">
					<div class="white--text font-weight-bold d-flex align-center">
						<v-icon color="white" class="mr-3">{{ icons.frameAssembly }}</v-icon>
						<span class="text-uppercase">{{ $t('frameAssembly.singular') }}</span>
					</div>
					<div v-if="!sMobile" class="d-flex justify-end mr-9">
						<AsiChip color="primary" text-color="white" small label>
							{{ $t('frameAssembly.terms.assemblyPossible') }}
						</AsiChip>
					</div>
					<template v-slot:actions>
						<v-icon color="white">{{ icons.dropdown }}</v-icon>
					</template>
				</v-expansion-panel-header>
				<v-expansion-panel-content color="grey lighten-5">
					<FrameAssemblyCreateDialog :item="item" />
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</AsiCard>
</template>

<script lang="ts">
	import {Component, Prop} from "vue-property-decorator";
	import AsiCard from "@/components/common/AsiCard.vue";
	import Icon from "@/plugins/icons";
	import AsiChip from "@/components/common/AsiChip.vue";
	import ItemCardFrameAssemblyFrame from "@/components/item/shop/ItemCardFrameAssemblyFrame.vue";
	import AsiTextField from "@/components/common/AsiTextField";
	import AsiTextarea from "@/components/common/AsiTextarea";
	import AsiRadioGroup from "@/components/common/AsiRadioGroup";
	import AsiTextFieldSimple from "@/components/common/AsiTextFieldSimple";
	import AsiTextareaSimple from "@/components/common/AsiTextareaSimple";
	import ItemAddToCartButton from "@/components/item/shop/ItemAddToCartButton.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import {mixins} from "vue-class-component";
	import ResponsiveChecks from "@/mixins/ResponsiveChecks.vue";
	import ItemCardFrameAssemblyTypeSelection from "@/components/item/shop/ItemCardFrameAssemblyTypeSelection.vue";
	import {IItemShopListEntry} from "@/models/item/ItemShopModels";
	import ItemQuantitySelection from "@/components/item/shop/ItemQuantitySelection.vue";
	import ItemPriceTable from "@/components/item/ItemPriceTable.vue";
	import FrameAssemblyConfigurator from "@/components/frame-assembly/FrameAssemblyConfigurator.vue";
	import ShoppingListButton from "@/components/shopping-list/shop/ShoppingListButton.vue";
	import CartSelectInput from "@/components/cart/shop/CartSelectInput.vue";
	import FrameAssemblyCreateForm from "@/components/frame-assembly/FrameAssemblyCreateForm.vue";

	@Component({
		components: {
			FrameAssemblyCreateDialog: FrameAssemblyCreateForm,
			CartSelectInput, ShoppingListButton,
			FrameAssemblyConfigurator,
			ItemPriceTable,
			ItemQuantitySelection,
			ItemCardFrameAssemblyTypeSelection,
			AsiBtn,
			ItemAddToCartButton,
			AsiTextareaSimple,
			AsiTextFieldSimple,
			AsiRadioGroup, AsiTextarea, AsiTextField, ItemCardFrameAssemblyFrame, AsiChip, AsiCard
		}
	})
	export default class ItemCardFrameAssembly extends mixins(ResponsiveChecks) {

		@Prop({type: Object, required: true})
		public item!: IItemShopListEntry;

		private icons = Icon;
	}
</script>

<style lang="scss" scoped>
	.card-expansion-header {
		height: 68px;
	}

	.v-expansion-panel-content::v-deep .v-expansion-panel-content__wrap {
		padding: 0 !important;
	}
</style>
